import React, { useState } from "react";
import { Button, Table } from "antd";
import CustomPagination from "../components/Pagination";
import type { TableColumnsType } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";

interface TaskTableProps {
  tasks: any[];
  onAddNote: (taskId: string, taskName: string) => void;
}

function TaskTable({ tasks, onAddNote }: TaskTableProps) {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 6;

  const columns: TableColumnsType<any> = [
    {
      title: "اسم المهمة",
      dataIndex: "name",
      key: "name",
      width: "70%",
    },
    {
      title: "إضافة ملاحظة",
      key: "action",
      width: "30%",

      render: (text: any, record: any) => (
        <div style={{ textAlign: "center" }}>
          <Button
            className="add-note-button"
            onClick={() => onAddNote(record.id, record.name)}
            icon={<PlusCircleOutlined />}
          />
        </div>
      ),
    },
  ];

  const paginatedTasks = tasks.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  return (
    <div>
      <Table
        columns={columns}
        dataSource={paginatedTasks}
        pagination={false}
        rowKey="id"
        locale={{
          emptyText: (
            <span className="ghaith--empty-text-table">
              لا توجد بيانات تخص المهام
            </span>
          ),
        }}
      />
      {tasks?.length > pageSize && (
        <CustomPagination
          current={currentPage}
          total={tasks.length}
          pageSize={pageSize}
          onChange={(page: any) => setCurrentPage(page)}
        />
      )}
    </div>
  );
}

export default TaskTable;
